import React, { FC, ReactNode } from 'react'
import {
  Typography,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  DialogActions,
  makeStyles,
} from 'transfix-ui/core'
import { calcRem } from 'transfix-ui/theme/typography'
import { IConfirmationModalProps } from 'transfix-ui'

interface IConfirmAssociationModalProps
  extends Omit<IConfirmationModalProps, 'actions' | 'title' | 'onClose'> {
  isLoading?: boolean
  onConfirm: () => void
  onCancel: () => void
  children: ReactNode
}

const useConfirmAssociationModalStyles = makeStyles(theme => ({
  titleWrapper: {
    padding: theme.spacing(3),
  },
  title: {
    [theme.breakpoints.down('lg')]: {
      fontSize: calcRem(18),
      lineHeight: '1.3',
    },
  },
}))

/**
 * Used to confirm if user wants to give dispatchers and drivers access to a carrier
 * in Create Load Modal
 */
export const ConfirmAssociationModal: FC<IConfirmAssociationModalProps> = ({
  children,
  isLoading,
  onCancel,
  onConfirm,
  open,
}) => {
  const classes = useConfirmAssociationModalStyles()
  return (
    <Dialog
      maxWidth='md'
      open={!!open}
      onClose={onCancel}
      scroll='paper'
      transitionDuration={0}
      data-test='confirm-association-modal'>
      <DialogTitle className={classes.titleWrapper}>
        <Typography variant='h3' className={classes.title} component='div'>
          Some team members don’t have access to this carrier
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        <Box mb={3}>
          <Typography variant='body2' component='div'>
            Do you want to give them access, so they can view and manage loads for this carrier?
          </Typography>
        </Box>
        <Box pb={2}>{children}</Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color='secondary'>
          Go Back to Editing
        </Button>
        <Button onClick={onConfirm} color='primary' disabled={isLoading}>
          {isLoading ? 'Loading...' : 'Grant Access'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
